export default {"src":"/_next/static/media/cricleImage.3320c023.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};